import type { Animation } from "excalibur";
import { Branded } from "./common";

export const CardKinds = [
  "fuel",
  "pops",
  "food",
  "ore",
  "fight",
  "admin",
] as const;
export type CardKind = (typeof CardKinds)[number];
export const KindSet = new Set(CardKinds);

export const CardLevels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] as const;
export const LevelSet = new Set(CardLevels);
export type CardLevel = (typeof CardLevels)[number];
export type CardName = `${CardKind}-${CardLevel}`;

export type CardTemplate = {
  //usesRemaining: number;
  name: PlayableId;
};

export type CardId = Branded<number, "CardId">;
export type Card = CardTemplate & {
  cardId: CardId; // "physical" card id
};

export interface TowerAnimationSet {
  idle: Animation;
  die: Animation;
  //spawn: Animation;
}

export const OreKinds = ["quarry", "mine", "smelter", "forge"] as const;

// ditch, field, farm,
export const FoodKinds = ["orchard", "farm", "field", "granary"] as const;

export const FuelKinds = ["logger", "charcoal", "coke"] as const;

export const FightKinds = ["arrow", "sword", "spear"] as const;

export const ResourceKinds = [
  ...OreKinds,
  ...FoodKinds,
  ...FuelKinds,
  ...FightKinds,
];

export type ResourceKind = (typeof ResourceKinds)[number];
// Accrued over time
export interface GameState {
  seenResources: Set<ResourceKind>; // Show tiny icons in the UX
  money: number; // Shown in UX
  turnCount: number; // Shown in UX, increments when buildings are placed
  seenTransforms: Set<PlayableId>; // Not shown!
}

// Calculated from board state, not kept!
// Eventually convert to money with warehouse

export type MatchKind = `${CardKind}-${CardLevel}`;

export const GameResources = [
  "ore",
  "food",
  "fuel",
  "fight",
  //"pops",
  "money",
] as const;
export type GameResource = (typeof GameResources)[number];
export type DynamicResources = Record<GameResource, number>; //{ [K in GameResource]: number };
export type ProvidesResources = { [K in GameResource]?: number };

//Record<GameResource, number>; //

export type CardPack = {
  name: string;
  description: string;
  cost: number;
  cards: {
    template: CardTemplate;
    weight: number;
  }[];
  required: ResourceKind[];
};

export type PlayableId = Branded<string, "PlayableId">;

export type Playable = {
  name: PlayableId;
  label: string;
  kind: CardKind;
  level: CardLevel;
  resources: DynamicResources;
  requiredUnlock: ResourceKind[];
  providesUnlock: ResourceKind[];
  combines: {
    ownMatchString: string;
    withMatchStrings: string[];
    into: PlayableId | undefined;
  };
};
